import {
  getTaskInvoice
} from "../../services/task.invoice.service";
import { validationErrors } from "../../utils/Helpers";
import * as types from "../types/task.invoice.types";

export const getTaskInvoiceDataAction = (data) => {
  return async (dispatch, getState) => {

    try {
      await getTaskInvoice(
        data,
        getState().authReducer.token,
        getState().authReducer.user.id
      ).then((res) => {
        // console.log('res.data: ',res.data);
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_TASK_INVOICE_DETAIL_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};